import { Link } from "react-router-dom";
import PageBanner from "../PageBanner";
import SocialMediaSidebar from "../SocialMediaSidebar";
import SectionHeader from "../SectionHeader";
import React from "react";
import {
  FaLightbulb,
  FaUserCheck,
  FaDumpster,
  FaComments,
  FaBalanceScale,
  FaRoute,
  FaUsersCog,
} from "react-icons/fa";
import { BsBookmarkHeartFill } from "react-icons/bs";
import platform1 from "../../assets/images-webp/platform1.webp";
import platform2 from "../../assets/images-webp/platform2.webp";
import ScrollToTopButton from "../ScrollToTopButton";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";

const features = [
  {
    icon: <FaUserCheck className="text-[#00D084] text-8xl pt-4" />,
    title: "Attendance Monitoring",
    description:
      "Track staff attendance in real-time across all zones to ensure timely and efficient waste management operations.",
  },
  {
    icon: <FaDumpster className="text-green-600 text-8xl pt-4" />,
    title: "Commercial Waste Management",
    description:
      "Manage and monitor waste collection from commercial establishments with optimized scheduling and compliance tracking.",
  },
  {
    icon: <FaComments className="text-yellow-500 text-8xl pt-4" />,
    title: "Citizen Grievance Portal",
    description:
      "Empower citizens to report waste-related issues and ensure timely resolution through an integrated grievance system.",
  },
  {
    icon: <FaBalanceScale className="text-sky-500 text-8xl pt-4" />,
    title: "Weighbridge Integration",
    description:
      "Digitally capture and monitor waste weight at processing points to maintain transparency and accurate reporting.",
  },
  {
    icon: <FaRoute className="text-red-500 text-8xl pt-4" />,
    title: "Vehicle & Route Management",
    description:
      "Optimize garbage truck routes, track vehicles in real time, and improve fuel efficiency with smart transport solutions.",
  },
  {
    icon: <FaUsersCog className="text-gray-600 text-8xl pt-4" />,
    title: "User & Role Management",
    description:
      "Easily manage user access, roles, and permissions across the system to maintain operational security and control.",
  },
];

const SwachhAJV = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="SwachhAJV"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Platform" },
          { label: "SwachhAJV" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="SwachhAJV @ AJEEVI"
          shareUrl="https://swachhajv.ajeevi.in/swachhajv"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>
      {/* Page content */}
      <div className="bg-white w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-justify">
        <div className="flex flex-col-reverse xl:flex-row items-center gap-10">
          {/* Left Content */}
          <div className="w-full xl:w-7/12">
            <h1 className="text-4xl font-bold text-[#00D084] mb-4">
              What is SwachhAJV?
            </h1>
            <h5 className="text-xl font-medium mb-4 text-black">
              At SwachhAjv, we harness the power of smart technology to
              revolutionize waste collection, segregation, and disposal. Our
              mission is to build cleaner, more sustainable cities by promoting
              responsible waste management practices and empowering communities
              with real-time data and eco-friendly solutions.
            </h5>
            <p className="text-black mb-4 text-lg">
              In recent years, the issue of solid waste management has become
              increasingly important due to the rapidly growing population and
              urbanization. Improper management of solid waste not only leads to
              environmental pollution but also poses a severe threat to human
              health. However, with the advancement of technology, Internet of
              Things (IoT) based solutions have emerged as a potential solution
              to address the solid waste management problem. These solutions use
              sensors and other IoT devices to monitor and manage waste
              collection, transportation, and disposal.
            </p>
            <p className="text-black mb-6 text-lg">
              Ajeevi Swachh Smart Waste Management solution is an IoT-based
              waste management solution that tracks and monitors the waste
              management process right from households to the transfer stations
              / dump-yards and provides real time statistics related to waste
              collection and management related processes.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <FaLightbulb className="text-[#00D084] text-[150px]" />
                <div>
                  <h4 className="text-xl font-bold text-black mb-1">
                    Business Consulting
                  </h4>
                  <p className="text-black text-lg">
                    We provide expert guidance on sustainable waste strategies,
                    helping municipalities and businesses optimize collection,
                    reduce landfill use, and adopt eco-friendly practices.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <BsBookmarkHeartFill className="text-[#00D084] text-[160px]" />
                <div>
                  <h4 className="text-xl font-bold text-black mb-1">
                    Year Of Expertise
                  </h4>
                  <p className="text-black text-lg">
                    With extensive experience in waste management and
                    sustainable practices, we deliver smart, data-driven
                    solutions that drive real environmental impact.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-full xl:w-5/12 relative">
            <div className="rounded overflow-hidden ">
              <img
                src={platform1}
                alt="Smart Waste"
                className="w-full h-auto object-cover rounded-t"
              />
              <img
                src={platform2}
                alt="Decorative"
                className="w-full h-auto object-cover rounded-b"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-white px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-justify">
        <div className="text-center max-w-4xl mx-auto mb-12">
          <h4 className="text-[#00D084] text-2xl font-semibold mb-2">
            Our Features
          </h4>
          <h1 className="text-3xl md:text-5xl font-bold mb-4">
            Efficient, Sustainable, and Tech-Driven Waste Management
          </h1>
          <p className="text-black text-lg">
            We are committed to transforming urban waste management through
            intelligent systems and sustainable practices, ensuring cleaner
            cities and a healthier environment for future generations.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-100 rounded shadow hover:shadow-lg transition p-6 text-center"
            >
              <div className="flex justify-center items-center mb-4">
                {feature.icon}
              </div>
              <h4 className="text-2xl font-semibold text-gray-800 mb-3">
                {feature.title}
              </h4>
              <p className="text-black text-lg">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SwachhAJV;
